module.exports = __webpack_public_path__ + "img/rota-ida.92157917.png";